import type { FilterSpecification } from "mapbox-gl"
import { TransactionParkingType } from "@/graphql"

export function transactionParkingFilter(
	filter:
		| {
				parkingTypes?: TransactionParkingType[] | null
		  }
		| undefined
): FilterSpecification {
	if (!filter?.parkingTypes?.length) return ["all"]
	const indoor = ["get", "has_indoor_parking"]
	const outdoor = ["get", "has_outdoor_parking"]
	const predicates: Record<TransactionParkingType, unknown[]> = {
		[TransactionParkingType.Indoor]: ["==", indoor, true],
		[TransactionParkingType.Outdoor]: ["==", outdoor, true],
		[TransactionParkingType.None]: ["all", ["==", indoor, false], ["==", outdoor, false]],
		[TransactionParkingType.Unknown]: [
			"all",
			["!=", indoor, true],
			["!=", outdoor, true],
			["any", ["==", indoor, null], ["==", outdoor, null]],
		],
	}
	return ["any", ...filter.parkingTypes.map(type => predicates[type])] as FilterSpecification
}
